import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
// import { useFormikContext } from 'formik';
import ButtonNavigation from '../../../ButtonNavigation/ButtonNavigation';
import styles from './RegisterNavigation.module.scss';
import allActions from '../../../../store/actions';
import buildPATHS from '../../../../utils/paths';
import { getTranslation } from '../../../../utils/functions';

import {
  currentStepSelector,
  isRedirectFromSummarySelector,
  stepsSelector,
} from '../../../../store/selectors/formConfigSelectors';
import {
  errorPageSelector,
  formInitialValuesSelector,
} from '../../../../store/selectors/appSelectors';
import {
  showSummarySelector,
  textsOverwritingsSelector,
} from '../../../../store/selectors/globalConfigSelectors';

const RegisterNavigation = ({
  submitForm,
  setStepToRedirect,
  formValues,
  disabled,
  validateForm,
}) => {
  const {
    formInitialValues,
    errorPage,
    currentStep,
    isRedirectFromSummary,
    stepsLength,
    showSummary,
    textsOverwritings,
    // selectedCountry
  } = useSelector((state) => ({
    // app state
    formInitialValues: formInitialValuesSelector(state),
    errorPage: errorPageSelector(state),
    // formConfig state
    currentStep: currentStepSelector(state),
    isRedirectFromSummary: isRedirectFromSummarySelector(state),
    stepsLength: stepsSelector(state)?.length,
    // globalConfig state
    showSummary: showSummarySelector(state),
    textsOverwritings: textsOverwritingsSelector(state),
    // selectedCountry: countrySelector(state),
  }));

  // const { values } = useFormikContext();

  const dispatch = useDispatch();
  const { t } = useTranslation();
  // if(values.nativeResident !== "" && selectedCountry === undefined) {
  //   dispatch(allActions.formConfigActions.setSelectedCountry(values.nativeResident));

  // }

  const goBackToSummary = () => {
    dispatch(allActions.formConfigActions.setBackFromSummary(false));
    dispatch(allActions.formConfigActions.setFormStep(stepsLength));
  };

  const saveAndGoBack = () => {
    dispatch(allActions.formConfigActions.setRegisterData(formValues, currentStep));
    dispatch(
      allActions.appConfigActions.setFormInitialValues({ ...formInitialValues, ...formValues }),
    );
    dispatch(allActions.formConfigActions.setFormStep(currentStep - 1));
  };

  const isNextStepSummary = currentStep + 1 === stepsLength;

  const handleNextStepClick = () => {
    if (currentStep >= stepsLength) return;

    setStepToRedirect(currentStep + 1);
    submitForm();
  };

  const handlePrevStepClick = () => {
    if (isRedirectFromSummary) {
      goBackToSummary();
      return;
    }

    validateForm().then((errors) => {
      const isDataCorrect = Object.entries(errors).length === 0;
      dispatch(allActions.formConfigActions.setAcceptedSteps(currentStep, isDataCorrect));
      saveAndGoBack();
    });
  };

  const wrapperClasses = cx(styles.buttonsNavigation, {
    [styles.firstStep]: isRedirectFromSummary ? false : currentStep === 0,
  });
  const getNextButtonLabel = () => {
    if (isNextStepSummary) {
      return showSummary
        ? getTranslation(textsOverwritings, 'BUTTON_GO_TO_SUMMARY_STEP') ||
            t('BUTTON_GO_TO_SUMMARY_STEP')
        : getTranslation(textsOverwritings, 'BUTTON_SEND_FORM') || t('BUTTON_SEND_FORM');
    }

    return isRedirectFromSummary
      ? getTranslation(textsOverwritings, 'BUTTON_SAVE_CHANGES') || t('BUTTON_SAVE_CHANGES')
      : getTranslation(textsOverwritings, 'BUTTON_FORM_NEXT') || t('BUTTON_FORM_NEXT');
  };

  const BackButtonNavigation = () => {
    if (isRedirectFromSummary || currentStep !== 0)
      return (
        <ButtonNavigation onClick={handlePrevStepClick} back>
          {getTranslation(textsOverwritings, 'BUTTON_FORM_BACK') || t('BUTTON_FORM_BACK')}
        </ButtonNavigation>
      );

    return null;
  };

  const buttonsTemplate = (
    <>
      {BackButtonNavigation()}
      <ButtonNavigation type="submit" onClick={handleNextStepClick} next disabled={disabled}>
        {getNextButtonLabel()}
      </ButtonNavigation>
    </>
  );

  const PATHS = buildPATHS();
  const history = useHistory();

  useEffect(() => {
    if (errorPage) {
      history.push(PATHS.error_page);
    }
  }, [errorPage, PATHS, history]);

  return <section className={wrapperClasses}>{buttonsTemplate}</section>;
};

RegisterNavigation.propTypes = {
  submitForm: PropTypes.func.isRequired,
  setStepToRedirect: PropTypes.func.isRequired,
  validateForm: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formValues: PropTypes.object,
  disabled: PropTypes.bool.isRequired,
};

RegisterNavigation.defaultProps = {
  formValues: {},
};

export default RegisterNavigation;
